import { GET_CLIENT_SECRET_BY_COMPANY_ID } from "../constants";

const initState = {
  clientSecretList: [],
};

const clientSecret = (state = initState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_CLIENT_SECRET_BY_COMPANY_ID: {
      return {
        ...state,
        clientSecretList: payload,
      };
    }
    default:
      return state;
  }
};

export default clientSecret;
